export default __webpack_public_path__ + "static/media/cross-icon.51fb7f83.svg";